import { useStoreActions } from "easy-peasy";

export const useCreateToast = () => {
  const addToast = useStoreActions((actions) => actions.toasts.addToast);
  return (color, message) =>
    addToast({
      color,
      message,
    });
};
